import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { projects } from "../data/projects";
import { ProjectCard } from "./ProjectCard";
import { SectionHeading } from "./SectionHeading";
export function ProjectsSection() {
  const reduce = useReducedMotion();
  return <section id="projects" aria-labelledby="projects-heading" className="w-full scroll-mt-28 bg-cream px-6 pb-24 md:scroll-mt-36 md:px-12 md:pb-32 lg:px-20 lg:pb-40" data-id="element-350" data-mp="1kco9zyjftxf2">
      <SectionHeading id="projects-heading" title="RECENT LARGE-SCALE PROJECTS" data-id="element-351" data-mp="roa8h8t54iyr" />

      <div className="mt-24 grid grid-cols-1 gap-x-8 gap-y-14 md:mt-32 md:grid-cols-2 lg:mt-40" data-id="element-352" data-mp="rq3jf0asdpck">
        {projects.map((project, i) => <motion.div key={project.id} className="h-full" initial={reduce ? false : {
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1],
        delay: i % 2 * 0.06
      }} data-id="element-353" data-mp="11mq3hmvagcdj" data-mpi={i}>
            <ProjectCard project={project} data-id="element-354" data-mp="39wy7xi7ivdx6" />
          </motion.div>)}
      </div>
    </section>;
}